import { Component, Input } from '@angular/core';
import { SettlementInvoiceStatus } from '@app/services/bavel-payment-manager-client.service';

@Component({
  selector: 'app-pending-invoice-banner',
  templateUrl: './pending-invoice-banner.component.html',
  styleUrls: ['./pending-invoice-banner.component.scss'],
  standalone: false
})
export class PendingInvoiceBannerComponent {
  @Input() public settlementReviewStatus: SettlementInvoiceStatus | undefined;
  @Input() public billBackBillingUrl: string | undefined;
  @Input() public onClose: (() => void) | undefined;

  public get shouldShow(): boolean {
    return this.settlementReviewStatus === SettlementInvoiceStatus.MissingRequiredInvoice
      || this.settlementReviewStatus === SettlementInvoiceStatus.Defaulter;
  }

  public get shouldShowFuturePaymentsBlocked(): boolean {
    return this.settlementReviewStatus === SettlementInvoiceStatus.Defaulter;
  }
}